import { Pipe, PipeTransform } from '@angular/core';
import { DocumentPersonneAvertieResult } from '../../../data-domains/document-securite/entities/document-personne-avertie-result';

type EtatPa = {
	[code: string]: string;
}

const etatsPa: EtatPa = {
	'BROUILLON': 'Brouillon',
	'A_FAIRE_SIGNER': 'A faire signer',
	'ENVOYE_VIA_DOCUSIGN': 'Envoyé via DocuSign',
	'SIGNE_PARTIELLEMENT': 'Signé partiellement',
	'SIGNE': 'Signé',
	'ATTENTE_DE_RELECTURE': 'Attente de relecture',
	'INVALIDE': 'Invalidé'
};

@Pipe({
	name: 'libelleEtatPa'
})
export class LibelleEtatPaPipe implements PipeTransform {

	transform(pa: DocumentPersonneAvertieResult): string {
		let etat: string = '';
		if (pa.obsolete) {
			etat = 'Archivé';
		} else {
			etat = etatsPa[pa.etat];
		}
		return etat;
	}
}